<template>
  <div
    :style="style"
    :class="['xmas-decoration-lights', 'pointer-events-none', className]"
    v-bind="remainingProps"
  >
    <div
      v-for="(bgClass, index) in backgroundClasses"
      :key="index"
      :style="{
        opacity: index === currentImageIdx ? 1 : 0,
        position: 'absolute',
        height: '100%',
        width: '100%',
      }"
      :class="[bgClass, { visible: index === currentImageIdx, hidden: index !== currentImageIdx }]"
    />
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: "",
    },
    style: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      backgroundClasses: ["bg-light-1", "bg-light-2", "bg-light-3", "bg-light-4"],
      currentImageIdx: 0,
    };
  },
  computed: {
    remainingProps() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { className, style, ...rest } = this.$attrs;
      return rest;
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.currentImageIdx = (this.currentImageIdx + 1) % this.backgroundClasses.length;
    }, 500);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.xmas-decoration-lights {
  position: relative;
  overflow: hidden;
}

.xmas-decoration-lights > div {
  position: absolute;
  height: 100%;
  width: 100%;
}

.visible {
  opacity: 1;
}

.hidden {
  opacity: 0;
}

.bg-light-1 {
  background: url("./assets/lights_01.png") top left / contain;
}

.bg-light-2 {
  background: url("./assets/lights_02.png") top left / contain;
}

.bg-light-3 {
  background: url("./assets/lights_03.png") top left / contain;
}

.bg-light-4 {
  background: url("./assets/lights_04.png") top left / contain;
}
</style>
